import { useSearchParams } from "react-router-dom";
import { CalendarCheck, ExternalLink } from "lucide-react";
import { PageHeader, Reveal } from "@/components/site/Reveal";
import { InquiryForm, TYPES } from "@/components/site/InquiryForm";
import { useContent } from "@/context/ContentContext";

export default function Booking() {
  const [params] = useSearchParams();
  const c = useContent();
  const t = params.get("type");
  const type = TYPES[t] ? t : "pristilbud";
  const sumup = c?.settings?.sumup_url;
  return (
    <div data-testid="booking-page">
      <PageHeader eyebrow="Booking" title="Bestill tid eller be om pristilbud" intro="Vanlige timer bestilles direkte i kalenderen. Brudekjoler, spesialoppdrag og kurs starter med en forespørsel." testid="booking-header" />
      <section className="px-6 md:px-16 lg:px-24 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <div className="bg-[#F0EBE1] p-10 md:p-12" data-testid="sumup-booking-card">
            <CalendarCheck className="w-8 h-8 text-[#8C6E48]" strokeWidth={1.2} />
            <h2 className="text-3xl md:text-4xl font-medium mt-6">Bestill time i kalenderen</h2>
            <p className="mt-4 text-sm text-[#5C5A56] leading-relaxed">Gratis prøvetime (10–15 min), opplegging av bukser og justering av ermelengde kan bestilles direkte. Kalenderen viser alltid ledige tider.</p>
            <a href={sumup} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-3 px-8 py-4 bg-[#1A1A1A] text-[#FDFBF7] text-sm hover:bg-[#8C6E48] transition-colors" data-testid="sumup-book-btn">
              Åpne bookingkalender <ExternalLink className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <p className="mt-5 text-xs text-[#5C5A56]">Booking håndteres av SumUp Bookings – én felles kalender, så ingen dobbeltbookinger.</p>
          </div>
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <div id="forespørsel" className="scroll-mt-28">
            <p className="eyebrow mb-3">Forespørsel</p>
            <h2 className="text-3xl md:text-4xl font-medium mb-8">Pristilbud, brudekjole eller kurs</h2>
            <InquiryForm key={type} defaultType={type} />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
